import { render, staticRenderFns } from "./ManageSurveys.vue?vue&type=template&id=628a176c&scoped=true&"
import script from "./ManageSurveys.vue?vue&type=script&lang=js&"
export * from "./ManageSurveys.vue?vue&type=script&lang=js&"
import style0 from "./ManageSurveys.vue?vue&type=style&index=0&id=628a176c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a176c",
  null
  
)

export default component.exports